<template>
  <div class="mb-5">
    <div class="d-flex">
      <campaign-stat-section-heading
        title="Awareness"
        description="Total number of times your ads were shown to a property intending audience across all media channels"
        :loading="loading"
      ></campaign-stat-section-heading>
    </div>
    <div class="stat-items-container" v-if="adImpressions">
      <stat-item-card
        :value="adImpressions"
        label="Ad Impressions"
        tooltip="Total number of times your ads were shown to a property intending audience across all media channels"
      ></stat-item-card>
    </div>
    <no-stat-data-available
      v-if="!adImpressions && !loading"
      sectionTitle="awareness"
    ></no-stat-data-available>
  </div>
</template>

<script>
import StatItemCard from './StatItemCard.vue';
import CampaignStatSectionHeading from './CampaignStatSectionHeading.vue';
import NoStatDataAvailable from './NoStatDataAvailable.vue';

export default {
  props: ['adImpressions', 'loading'],
  components: {
    StatItemCard,
    CampaignStatSectionHeading,
    NoStatDataAvailable
  },
};
</script>

<style>
.stat-items-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 24px;
}
</style>
